import React, { useContext } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import AntiCorruption from '../components/Achievements/AntiCorruption';
import Infrastructure from '../components/Achievements/Infrastructure';
import Introduction from '../components/Achievements/Introduction';
import Privacy from '../components/Achievements/Privacy';
import Download from '../components/Home/Download';
import AchievementsBanner from '../components/Achievements/AchievementsBanner';
import { isMobileContext } from '../components/context/isMobileContext';
export default function Services() {
    const {t} = useTranslation();
    const {isMobile}=useContext(isMobileContext)
    const bannerData = {
        our: t("services_page.banner.our"),
        headline1: t("services_page.banner.headLine1"),
        headline2: t("services_page.banner.headLine2-1"),
        description: t("services_page.banner.description"),
        worldClass: t("services_page.banner.world_class"),
        img: '/imgs/achievements/achv_services_banner.png'
      }

      const infraData = {
        subtitle : t("services_page.Infrastructure1.subtitle"),
        title1: t("services_page.Infrastructure1.title1"),
        title2: t("services_page.Infrastructure1.title2"),
        desc: t("services_page.Infrastructure1.description"),
        cardsData: [
          {
            title: t("services_page.Infrastructure1.cardsDataTitle1"),
            img: t("services_page.Infrastructure1.img1")
          },
          {
            title: t("services_page.Infrastructure1.cardsDataTitle2"),
            img: t("services_page.Infrastructure1.img2")
          },
          {
            title: t("services_page.Infrastructure1.cardsDataTitle3"),
            img: t("services_page.Infrastructure1.img3")
          },
          {
            title: t("services_page.Infrastructure1.cardsDataTitle4"),
            img: t("services_page.Infrastructure1.img4")
          }
        ]
      }

      const happinessData = {
        subtitle : t("services_page.Infrastructure2.subtitle"),
        title1: t("services_page.Infrastructure2.title1"),
        desc: t("services_page.Infrastructure2.description"),
        cardsData: [
          {
            title: t("services_page.Infrastructure2.cardsDataTitle1"),
            img: t("services_page.Infrastructure2.img1"),
          },
          {
            title: t("services_page.Infrastructure2.cardsDataTitle2"),
            img: t("services_page.Infrastructure2.img2"),
          },
          {
            title: t("services_page.Infrastructure2.cardsDataTitle3"),
            img: t("services_page.Infrastructure2.img3"),      
          }
        ]
      }

      const privacyData = {
        line1: t("services_page.privacy.line1"),
        line2: t("services_page.privacy.line2"),
        descriptions : [
          t("services_page.privacy.descriptions1"),
          t("services_page.privacy.descriptions2")
        ],
        img: t("services_page.privacy.img")
      }

      const lawsData = {
        line1: t("services_page.lawsData.line1"),
        line2: t("services_page.lawsData.line2"),
        descriptions: [
          t("services_page.lawsData.descriptions1"),
          t("services_page.lawsData.descriptions2"),
          t("services_page.lawsData.descriptions3")
        ],
        img: '/imgs/achievements/achievements-graph/Enforcement-Laws-and-Regulations.svg'
      }

      const safetyData = {
        line1: t("services_page.safetyData.line1"),
        line2: t("services_page.safetyData.line2"),
        descriptions: [
          t("services_page.safetyData.descriptions1"),
        ],
        img: '/imgs/achievements/achievements-graph/Food-Safety-and-Hygiene.svg'
      }

      const antiCorruption = {
        line1: t("services_page.AntiCorruption.line1"),
        description: t("services_page.AntiCorruption.description")
      }

  return (
    <div>
        <Helmet>
            <title>{t('head.services')}</title>
        </Helmet>
        <AchievementsBanner bannerData={bannerData} uniqueClass={"services"}/>
        {/* <Introduction uniqueClass={"services"}/> */}
        <Infrastructure data={infraData} section={"infraSection"} normalSwiperLayers uniqueClass={"services"} />
        <Infrastructure data={happinessData} section={"happinessSection"}  invertedSwiper={isMobile?false:true} uniqueClass={"services"}/>
        <Privacy data={privacyData} privacySection privacyLayer1={isMobile?false:true} normalSwiperLayers={isMobile?true:false}  uniqueClass={"services"}/>
        <Privacy data={lawsData} invertedSection lawsSection environmentMobileLayer={isMobile?true:false} uniqueClass={"services"}/>
        <Privacy data={safetyData} safetySection privacyLayer2 markerOnly={isMobile?true:false}  uniqueClass={"services"}/>
        <AntiCorruption data={antiCorruption} normalSwiperLayers={isMobile?true:false}  uniqueClass={"services"}/>
        {/* <Download/> */}

        {/* <Infrastructure data={infraData} section={"infraSection"} normalSwiperLayers uniqueClass={"services"} />
        <Infrastructure data={happinessData} section={"happinessSection"} invertedSwiper uniqueClass={"services"}/>
        <Privacy data={privacyData} privacySection privacyLayer1 environmentLayer={isMobile?true:false}   uniqueClass={"services"}/>
        <Privacy data={lawsData} invertedSection lawsSection environmentMobileLayer={isMobile?true:false} uniqueClass={"services"}/>
        <Privacy data={safetyData} safetySection privacyLayer2 markerOnly={isMobile?true:false} uniqueClass={"services"}/>
        <AntiCorruption data={antiCorruption}  uniqueClass={"services"}/> */}
    </div>
  )
}
